import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue";
const _hoisted_1 = { class: "flex items-center border-b-2 border-gray-100 pb-4" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("em", { class: "fa fa-chevron-left mr-1 text-sm cursor-pointer" }, null, -1);
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = { class: "flex-shrink-0" };
const _hoisted_5 = { class: "capitalize text-md text-primary font-bold truncate ml-2 font-noto" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "flex-grow" }, null, -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-pen cursor-pointer" }, null, -1);
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = { class: "flex flex-col mx-1" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("div", { class: "flex flex-row justify-between items-center" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "max-w-full mt-4" }, [
        /*#__PURE__*/ _createElementVNode("h2", { class: "font-bold pb-2 text-sm truncate font-noto" }, "Details"),
        /*#__PURE__*/ _createElementVNode("span", { class: "line" })
    ])
], -1);
const _hoisted_11 = { class: "py-4" };
const _hoisted_12 = { class: "grid grid-cols-12 grid-row items-center text-sm" };
const _hoisted_13 = { class: "text-gray-600 col-span-6 capitalize" };
const _hoisted_14 = { class: "col-span-6 capitalize" };
const _hoisted_15 = { class: "grid grid-cols-12 grid-row items-center text-sm" };
const _hoisted_16 = { class: "text-gray-600 col-span-6 capitalize" };
const _hoisted_17 = { class: "col-span-6 capitalize" };
const _hoisted_18 = { class: "grid grid-cols-12 grid-row items-center text-sm" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("div", { class: "text-gray-600 col-span-6" }, "Email", -1);
const _hoisted_20 = { class: "col-span-6 truncate" };
const _hoisted_21 = { class: "grid grid-cols-12 grid-row items-center text-sm" };
const _hoisted_22 = { class: "text-gray-600 col-span-6" };
const _hoisted_23 = { class: "col-span-6" };
const _hoisted_24 = { class: "grid grid-cols-12 grid-row items-center text-sm capitalize" };
const _hoisted_25 = { class: "text-gray-600 col-span-6" };
const _hoisted_26 = { class: "col-span-6" };
const _hoisted_27 = { class: "flex flex-col overflow-hidden h-full" };
const _hoisted_28 = {
    key: 0,
    class: "overflow-hidden h-full"
};
const _hoisted_29 = {
    key: 1,
    class: "mb-3"
};
const _hoisted_30 = {
    key: 0,
    class: "text-sm text-center text-primary font-bold mb-1 mt-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_avatar = _resolveComponent("avatar");
    const _component_Tab = _resolveComponent("Tab");
    const _component_admin_vault_user_overview = _resolveComponent("admin-vault-user-overview");
    const _component_data_table = _resolveComponent("data-table");
    const _component_details_sidebar = _resolveComponent("details-sidebar");
    return (_openBlock(), _createBlock(_component_details_sidebar, null, _createSlots({
        header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('collapse-sidebar'))),
                    class: "mr-2"
                }, _hoisted_3),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_avatar, {
                        class: "w-10 h-10",
                        "round-size": "full",
                        src: `https://picsum.photos/seed/${_ctx.selectedVaultUser.id}/300/300`
                    }, null, 8, ["src"])
                ]),
                _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.selectedVaultUser.username), 1),
                _hoisted_6,
                _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('edit-user'))),
                    class: "ml-6"
                }, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('misc.firstname')), 1),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.selectedVaultUser.firstname ? _ctx.selectedVaultUser.firstname : '#'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('misc.lastname')), 1),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.selectedVaultUser.lastname ? _ctx.selectedVaultUser.lastname : '#'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.selectedVaultUser.email), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('misc.registered')), 1),
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.selectedVaultUser.joinDate ? _ctx.formatDate(_ctx.selectedVaultUser.joinDate, false) : _ctx.$t('misc.neverLoggedIn')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('role.role')), 1),
                        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.selectedVaultUser.role), 1)
                    ])
                ])
            ])
        ]),
        _: 2
    }, [
        (_ctx.selectedVaultUser)
            ? {
                name: "content",
                fn: _withCtx(() => [
                    _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_Tab, {
                            selectedTab: _ctx.currentTab,
                            "onUpdate:selectedTab": _cache[2] || (_cache[2] = ($event) => ((_ctx.currentTab) = $event)),
                            tabs: _ctx.tabs
                        }, null, 8, ["selectedTab", "tabs"]),
                        (_ctx.currentTab === _ctx.tabs[0])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createVNode(_component_admin_vault_user_overview, {
                                    onClickedVaultName: _ctx.goToPersonalSpace,
                                    selectedVaultUser: _ctx.selectedVaultUser
                                }, null, 8, ["onClickedVaultName", "selectedVaultUser"])
                            ]))
                            : (_ctx.currentTab === _ctx.tabs[1])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    (_ctx.userLoginHistory.length === 0)
                                        ? (_openBlock(), _createElementBlock("h4", _hoisted_30, _toDisplayString(_ctx.selectedVaultUser.username) + " " + _toDisplayString(_ctx.$t('user.hasNoLoginHistory')), 1))
                                        : (_openBlock(), _createBlock(_component_data_table, {
                                            key: 1,
                                            name: "userLoginHistory",
                                            headers: ['ip', 'date', 'status', 'geolocation'],
                                            "selected-fields": ['requestIp', 'loginAttempt', 'status', 'location'],
                                            data: _ctx.userLoginHistory,
                                            "has-more": _ctx.userLoginHistory.length >= 5,
                                            onShowMore: _ctx.addMore,
                                            "max-height": "35vh",
                                            class: "mt-4"
                                        }, null, 8, ["data", "has-more", "onShowMore"]))
                                ]))
                                : _createCommentVNode("", true)
                    ])
                ])
            }
            : undefined
    ]), 1024));
}
